import React from "react";
import { RenderCellFn } from "./types";
import RemediationIndicator from "../../RemediationIndicator/RemediationIndicator";
import styled from "styled-components";

export const renderRemediationCell: RenderCellFn = ({ column, item }) => {
  if (column?.key !== "remediationComplexity") {
    return null;
  }

  const complexityLevel = item?.remediationComplexity || "none";

  return (
    <Wrap title={complexityLevel.replace(/^./, complexityLevel[0].toUpperCase())}>
      <RemediationIndicator level={complexityLevel} hideTooltip />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
